/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_Uppercase_LabelInputs */

const en_insert_speaker_uppercase_label = /** @type {(inputs: Insert_Speaker_Uppercase_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppercase All`)
};

const fr_insert_speaker_uppercase_label = /** @type {(inputs: Insert_Speaker_Uppercase_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout en majuscules`)
};

const de_insert_speaker_uppercase_label = /** @type {(inputs: Insert_Speaker_Uppercase_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Großbuchstaben`)
};

const it_insert_speaker_uppercase_label = /** @type {(inputs: Insert_Speaker_Uppercase_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto maiuscolo`)
};

const ru_insert_speaker_uppercase_label = /** @type {(inputs: Insert_Speaker_Uppercase_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все заглавными буквами`)
};

const es_insert_speaker_uppercase_label = /** @type {(inputs: Insert_Speaker_Uppercase_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo en mayúsculas`)
};

const zh_cn2_insert_speaker_uppercase_label = /** @type {(inputs: Insert_Speaker_Uppercase_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部大写`)
};

const ja_insert_speaker_uppercase_label = /** @type {(inputs: Insert_Speaker_Uppercase_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて大文字`)
};

const hi_insert_speaker_uppercase_label = /** @type {(inputs: Insert_Speaker_Uppercase_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी अक्षर बड़े अक्षरों में`)
};

const pt_pt2_insert_speaker_uppercase_label = /** @type {(inputs: Insert_Speaker_Uppercase_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo em maiúsculas`)
};

/**
* | output |
* | --- |
* | "Uppercase All" |
*
* @param {Insert_Speaker_Uppercase_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_uppercase_label = /** @type {((inputs?: Insert_Speaker_Uppercase_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_Uppercase_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_insert_speaker_uppercase_label(inputs)
	if (locale === "de") return de_insert_speaker_uppercase_label(inputs)
	if (locale === "it") return it_insert_speaker_uppercase_label(inputs)
	if (locale === "ru") return ru_insert_speaker_uppercase_label(inputs)
	if (locale === "es") return es_insert_speaker_uppercase_label(inputs)
	if (locale === "zh-CN") return zh_cn2_insert_speaker_uppercase_label(inputs)
	if (locale === "ja") return ja_insert_speaker_uppercase_label(inputs)
	if (locale === "hi") return hi_insert_speaker_uppercase_label(inputs)
	if (locale === "pt-PT") return pt_pt2_insert_speaker_uppercase_label(inputs)
	return en_insert_speaker_uppercase_label(inputs)
});